import React from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
  withStyles,
  Paper,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import swal from '@sweetalert/with-react';

import axiosInstance, { EVENT_ID, getUserID, WEB_API } from '../constatns';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';

import './ReviewWin.css';

const styles = (theme) => ({
  newWin: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  wrapper: {
    padding: theme.spacing(2, 3),
  },
  header: {
    fontSize: '1.5em',
    fontWeight: 550,
    color: theme.palette.primary.main,
  },
  abstractWrapper: {
    padding: theme.spacing(1, 2, 4),
  },
  abstractNo: {
    border: '1px solid #000',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
  },
  abstractTitle: {
    padding: theme.spacing(1, 2),
    textAlign: 'center',
    fontSize: '1.5em',
    fontWeight: 550,
  },
  abstractAuthor: {
    textAlign: 'center',
    fontSize: '1.1em',
  },
  abstractAffiliation: {
    padding: theme.spacing(1),
    textAlign: 'center',
    fontSize: '1.1em',
  },
  abstractContent: {
    padding: theme.spacing(2, 0),
    fontSize: '1em',
    textAlign: 'justifyContent',
  },
  abstractContentTable: {
    '& th': {
      width: '20%',
      textAlign: 'center',
    },
    '& td': {
      width: '80%',
    },
  },
  abstractFigures: {
    padding: theme.spacing(2, 1),
  },
  reviewTable: {
    marginTop: theme.spacing(3),
  },
  tableBody: {
    '& th': {
      width: '20%',
      textAlign: 'center',
      fontWeight: 'normal',
    },
    '& td': {
      width: '80%',
    },
    '& label:not(:last-child)': {
      marginRight: theme.spacing(3),
    },
  },
  buttonArea: {
    marginTop: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
  },
  popupDiv: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1111,
  },
  popupPaper: {
    display: 'block',
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '600px',
    padding: '7px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    zIndex: 2222,
  },
});

class ReviewWin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExtraComplete: false, //심사위원 가산점 배점횟수 2회넘는지 체크
      data: {},
      researchScore: 0,
      originalityScore: 0,
      concreteScore: 0,
      practicalityScore: 0,
      contributionScore: 0,
      comment: '',
      status: '',
      popUpOpen: false,
    };
  }

  componentDidMount() {
    const id = window.location.href.split('=')[1];
    // if (this.props.isAdmin) {
    this.loadData(this.props.abstractId);
    // } else {
    //   this.loadData(id);
    // }
  }

  loadData(abstractId) {
    axiosInstance
      .get(`${WEB_API}/paper/info?eventId=${EVENT_ID}&paperId=${abstractId}`, { headers: { Pragma: 'no-cache' } })
      .then((res) => {
        if (res.data.Item) {
          // console.log(res.data.Item);
          this.checkExtraPointCount(res.data.Item);
          this.setReviewData(res.data.Item);
          this.setState({ data: res.data.Item });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 심사위원의 가산점 배점 횟수 체크
  checkExtraPointCount(data) {
    if (data.judge && data.judge.length > 0) {
      for (let i = 0; i < data.judge.length; i++) {
        if (data.judge[i].id === getUserID(true)) {
          ///
          axiosInstance
            .get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${data.judge[i].id}`, { headers: { Pragma: 'no-cache' } })
            .then((_res) => {
              // console.log(_res.data.Item);
              if (_res.data.Item.contributionScore && _res.data.Item.contributionScore.length >= 2)
                this.setState({ isExtraComplete: true });
            });
          ///
          // console.log(getUserID(true));
          // console.log(data.judge[i]);
          // if (data.judge[i].contributionScore && data.judge[i].contributionScore.length >= 2) this.setState({ isExtraComplete: true });
        }
      }
    }
  }

  setReviewData(data) {
    if (data.reviewResult) {
      for (let i = 0; i < data.reviewResult.length; i++) {
        if (this.props.isAdmin) {
          if (data.reviewResult[i].reviewer === this.props.reviewerId) {
            this.setState({
              researchScore: data.reviewResult[i].researchScore,
              originalityScore: data.reviewResult[i].originalityScore,
              concreteScore: data.reviewResult[i].concreteScore,
              practicalityScore: data.reviewResult[i].practicalityScore,
              contributionScore: data.reviewResult[i].contributionScore,
              totalScore: data.reviewResult[i].totalScore,
              comment: data.reviewResult[i].comment,
              status: data.reviewResult[i].reviewStatus,
            });
          }
        } else {
          if (data.reviewResult[i].reviewer === getUserID(true)) {
            this.setState({
              researchScore: data.reviewResult[i].researchScore,
              originalityScore: data.reviewResult[i].originalityScore,
              concreteScore: data.reviewResult[i].concreteScore,
              practicalityScore: data.reviewResult[i].practicalityScore,
              contributionScore: data.reviewResult[i].contributionScore,
              totalScore: data.reviewResult[i].totalScore,
              comment: data.reviewResult[i].comment,
              status: data.reviewResult[i].reviewStatus,
            });
          }
        }
      }
    }
  }

  handleChange(e, type) {
    //researchScore, originalityScore, concreteScore, practicalityScore, contributionScore
    if (type === 'contributionScore' && this.state.isExtraComplete) {
      if (Number(e.target.value) === 3) {
        swal('', '심사위원 한 분에 초록 2개만 가산점을 허용합니다.', 'warning');
        return;
      } else {
        this.setState({ isExtraComplete: false });
      }
    }
    this.setState({ [type]: Number(e.target.value) });
  }

  handleSubmit(status) {
    const { researchScore, originalityScore, concreteScore, practicalityScore, contributionScore } = this.state;
    // if (this.state.isExtraComplete && this.state.contributionScore > 0) {
    //   swal('', '심사위원 한 분에 초록 2개만 가산점을 허용합니다.', 'warning');
    //   return;
    // } else {
    let swalText = status === 'temp' ? '리뷰를 저장하시겠습니까?' : '리뷰를 제출하시겠습니까?';
    let swalText2 = status === 'temp' ? '리뷰가 저장되었습니다.' : '리뷰가 제출되었습니다.';
    const totalScore = researchScore + originalityScore + concreteScore + practicalityScore + contributionScore;
    const paperId = this.props.abstractId;
    // const paperId = this.props.isAdmin ? this.props.abstractId : window.location.href.split('=')[1];
    const reviewer = this.props.isAdmin ? this.props.reviewerId : getUserID(true);
    const reviewParam = {
      evt: EVENT_ID,
      paperId: paperId,
      reviewer: reviewer,
    };

    // console.log(totalScore);

    for (const [key, value] of Object.entries(this.state)) {
      if (key !== 'data' && key !== 'isExtraComplete') reviewParam[key] = value;
    }

    if (status === 'temp') reviewParam['reviewStatus'] = 'Temporary';
    else reviewParam['reviewStatus'] = 'Complete';

    reviewParam['totalScore'] = totalScore;
    // console.log(reviewParam);

    swal({
      text: swalText,
      buttons: true,
    }).then((willSubmit) => {
      if (willSubmit) {
        axiosInstance
          .post(`${WEB_API}/paper/review/`, reviewParam)
          .then((res) => {
            if (res.status === 200) {
              swal(swalText2).then(() => {
                this.onClose();
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    });
    // }
  }

  onClose = () => {
    // if (this.props.isAdmin) {
    this.props.handleClose();
    // } else {
    //   window.opener.location.reload();
    //   window.opener = 'Self';
    //   window.open('', '_parent', '');
    //   window.close(); // 일반적인 현재 창 닫기
    //   window.open('about:blank', '_self').self.close(); // IE에서 묻지 않고 창 닫기
    // }
  };

  setPopupOpen() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'hidden';
    this.setState({ popUpOpen: true });
  }

  setPopupClose() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'auto';
    this.setState({ popUpOpen: false });
  }

  render() {
    const { classes, theme } = this.props;
    const { data, status, researchScore, originalityScore, concreteScore, practicalityScore, contributionScore, comment } = this.state;

    return (
      <div className={classes.newWin}>
        <div className={classes.wrapper}>
          <Typography className={classes.header}>Abstract Details</Typography>
          <Grid container className={classes.abstractWrapper}>
            <Grid item xs={12} className={classes.abstractNo}>
              <div>[{data.paperRegNo && data.paperRegNo}]</div>
            </Grid>
            <Grid item xs={12} className={classes.abstractTitle}>
              {data.abstractTitle && data.abstractTitle}
            </Grid>
            <Grid item xs={12} className={classes.abstractAuthor}>
              {data.numOfAuthor &&
                data.numOfAuthor.map((author, idx) => (
                  <React.Fragment key={`author-${idx}`}>
                    <span style={author.id === data.selectPresentingAuthor ? { textDecoration: 'underline' } : {}}>
                      {author.firstName} {author.lastName}
                    </span>
                    {idx < data.numOfAuthor.length - 1 && <span>, </span>}
                  </React.Fragment>
                ))}
            </Grid>
            <Grid item xs={12} className={classes.abstractAffiliation}>
              {data.numOfInstitution && (
                <span>
                  {data.numOfInstitution[0].department}, {data.numOfInstitution[0].affiliation}, {data.numOfInstitution[0].city},{' '}
                  {data.numOfInstitution[0].country}
                </span>
              )}
            </Grid>
            <Grid item xs={12} className={classes.abstractContent}>
              <Table>
                <TableBody className={classes.abstractContentTable}>
                  {data.purposeContent && (
                    <TableRow>
                      <TableCell component={'th'}>Purpose</TableCell>
                      <TableCell>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.purposeContent.replace(/<p>/g, '').replace(/<\/p>/g, '<br/>'),
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {data.methodsContent && (
                    <TableRow>
                      <TableCell component={'th'}>Methods</TableCell>
                      <TableCell>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.methodsContent.replace(/<p>/g, '').replace(/<\/p>/g, '<br/>'),
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {data.resultsContent && (
                    <TableRow>
                      <TableCell component={'th'}>Results</TableCell>
                      <TableCell>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.resultsContent.replace(/<p>/g, '').replace(/<\/p>/g, '<br/>'),
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  {data.conclusionContent && (
                    <TableRow>
                      <TableCell component={'th'}>Conclusion</TableCell>
                      <TableCell>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.conclusionContent.replace(/<p>/g, '').replace(/<\/p>/g, '<br/>'),
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={12} className={classes.abstractFigures}>
              {data.figures1 && (
                <div>
                  <img src={`${data.figures1.path}`} alt="" width="100%" />
                </div>
              )}
              {data.figures2 && (
                <div>
                  <img src={`${data.figures2.path}`} alt="" width="100%" />
                </div>
              )}
              {data.figures3 && (
                <div>
                  <img src={`${data.figures3.path}`} alt="" width="100%" />
                </div>
              )}
              {data.figures4 && (
                <div>
                  <img src={`${data.figures4.path}`} alt="" width="100%" />
                </div>
              )}
            </Grid>
          </Grid>
          <div className={classes.reviewTable}>
            <Typography className={classes.header} style={{ marginBottom: theme.spacing(1) }}>
              Abstract Review
            </Typography>
            <Table>
              <TableBody className={classes.tableBody}>
                <TableRow>
                  <TableCell component="th">학문적 가치</TableCell>
                  <TableCell>
                    <FormControl>
                      <RadioGroup row value={researchScore} onChange={(e) => this.handleChange(e, 'researchScore')}>
                        <FormControlLabel value={1} control={<Radio />} label="1(불량)" />
                        <FormControlLabel value={2} control={<Radio />} label="2(낮음)" />
                        <FormControlLabel value={3} control={<Radio />} label="3(보통)" />
                        <FormControlLabel value={4} control={<Radio />} label="4(우수)" />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">독창성</TableCell>
                  <TableCell>
                    <FormControl>
                      <RadioGroup row value={originalityScore} onChange={(e) => this.handleChange(e, 'originalityScore')}>
                        <FormControlLabel value={1} control={<Radio />} label="1(불량)" />
                        <FormControlLabel value={2} control={<Radio />} label="2(낮음)" />
                        <FormControlLabel value={3} control={<Radio />} label="3(보통)" />
                        <FormControlLabel value={4} control={<Radio />} label="4(우수)" />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">연구방법의 적절성</TableCell>
                  <TableCell>
                    <FormControl>
                      <RadioGroup row value={concreteScore} onChange={(e) => this.handleChange(e, 'concreteScore')}>
                        <FormControlLabel value={1} control={<Radio />} label="1(불량)" />
                        <FormControlLabel value={2} control={<Radio />} label="2(낮음)" />
                        <FormControlLabel value={3} control={<Radio />} label="3(보통)" />
                        <FormControlLabel value={4} control={<Radio />} label="4(우수)" />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">논리전개 및 결론도출</TableCell>
                  <TableCell>
                    <FormControl>
                      <RadioGroup row value={practicalityScore} onChange={(e) => this.handleChange(e, 'practicalityScore')}>
                        <FormControlLabel value={1} control={<Radio />} label="1(불량)" />
                        <FormControlLabel value={2} control={<Radio />} label="2(낮음)" />
                        <FormControlLabel value={3} control={<Radio />} label="3(보통)" />
                        <FormControlLabel value={4} control={<Radio />} label="4(우수)" />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">가산점</TableCell>
                  <TableCell>
                    <FormControl>
                      <RadioGroup row value={contributionScore} onChange={(e) => this.handleChange(e, 'contributionScore')}>
                        <FormControlLabel value={0} control={<Radio />} label="0" />
                        <FormControlLabel value={3} control={<Radio onClick={() => this.setState({ popUpOpen: true })} />} label="3" />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Total Score</TableCell>
                  <TableCell>{researchScore + originalityScore + concreteScore + practicalityScore + contributionScore}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Comment</TableCell>
                  <TableCell>
                    <TextField
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={5}
                      value={comment}
                      onChange={(e) => {
                        this.setState({ comment: e.target.value });
                      }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
          <div className={classes.buttonArea}>
            {status !== 'Complete' && (
              <>
                <ConfirmButton
                  color="secondary"
                  onClick={() => {
                    this.handleSubmit('temp');
                  }}
                >
                  Temporary Save
                </ConfirmButton>
                <div style={{ width: '20px' }} />
              </>
            )}
            <ConfirmButton
              color="primary"
              onClick={() => {
                if (!this.props.isAdmin && status && status === 'Complete') {
                  swal('이미 심사를 진행한 초록입니다. 수정을 원하시면 관리자에게 연락주세요.');
                } else {
                  this.handleSubmit();
                }
              }}
            >
              Save
            </ConfirmButton>
            <div style={{ width: '20px' }} />
            <ConfirmButton onClick={this.onClose}>Close</ConfirmButton>
          </div>

          {/* {this.state.popUpOpen && (
            <div id="popupDom" className={classes.popupDiv}>
              <Paper elevation={3} className={classes.popupPaper}>
                <Grid container justifyContent="flex-end">
                  <IconButton aria-label="close" onClick={() => this.setPopupClose()}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <DaumPostcode onComplete={handleComplete} style={{ height: '450px' }} />
              </Paper>
            </div>
          )} */}
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ReviewWin);
